<div class="language-select-container">
  <button class="language-button" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false" data-bs-tooltip="tooltip" data-bs-placement="bottom" [attr.title]="('LANGUAGE' | translate)">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g fill="none" stroke="#333333" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
        <path d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2S2 6.477 2 12"/>
        <path d="M13 2.05S16 6 16 12s-3 9.95-3 9.95m-2 0S8 18 8 12s3-9.95 3-9.95M2.63 15.5h18.74m-18.74-7h18.74"/>
      </g>
    </svg>
  </button>

  <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
    <li *ngFor="let option of languages">
      <a class="dropdown-item" [ngClass]="{'selected': selectedLanguage === option.value}" (click)="switchLanguage(option.value)">
        <span [class]="option.flagClass" class="flag-icon"></span>
        <span>{{ option.value === 'es' ? 'Español' : 'English' }}</span>
      </a>
    </li>
  </ul>
</div>
